import ThemeColours from '@onhandtech/onhand-toolkit/lib/src/themes/default/colours'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { DEFAULT_IMAGE_URL, QR_CODE_DEFAULT_URL } from 'pages/admin/qr-codes/qr-codes.constants'

import type { QrCodesState } from './qr-codes.types'
import { moduleName } from './qr-codes.types'

export const initialState: QrCodesState = {
  appearance: {
    backgroundColour: ThemeColours.cotton,
    cornerDotColour: ThemeColours.earth,
    cornerSquareColour: ThemeColours.earth,
    dotColour: ThemeColours.earth,
    imgUrl: DEFAULT_IMAGE_URL,
  },
  filename: 'qr-code.png',
  url: QR_CODE_DEFAULT_URL,
  blobUrl: null,
  blob: null,
}

const slice = createSlice({
  name: moduleName,
  initialState,
  reducers: {
    setDotColour: (state, action: PayloadAction<string>) => {
      state.appearance.dotColour = action.payload
    },
    setCornerDotColour: (state, action: PayloadAction<string>) => {
      state.appearance.cornerDotColour = action.payload
    },
    setCornerSquareColour: (state, action: PayloadAction<string>) => {
      state.appearance.cornerSquareColour = action.payload
    },
    setBackgroundColour: (state, action: PayloadAction<string>) => {
      state.appearance.backgroundColour = action.payload
    },
    setImage: (state, action: PayloadAction<string | undefined>) => {
      state.appearance.imgUrl = action.payload
    },
    setUrl: (state, action: PayloadAction<string>) => {
      state.url = action.payload
    },
    setFilename: (state, action: PayloadAction<string>) => {
      state.filename = action.payload
    },
    setBlobUrl: (state, action: PayloadAction<string>) => {
      state.blobUrl = action.payload
    },
    setBlob: (state, action: PayloadAction<Blob | null>) => {
      state.blob = action.payload
    },
    clearQrData: (state) => {
      state.appearance = initialState.appearance
      state.filename = initialState.filename
      state.url = initialState.url
      state.blobUrl = initialState.blobUrl
      state.blob = initialState.blob
    },
  },
})

export default slice
